import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getMMODictTreeApi, getMMOCalendarApi, getMMOByDateApi, postMMODataApi } from 'api/monitor/MMOApi'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    mmoData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
}

/* 获取日历上的数据 */
export const getMMOCalendarAction = createAsyncThunk('MMOSlice/getMMOCalendarAction', async (params, thunkAPI) => {
    try {
        const result = await getMMOCalendarApi(params)
        return result?.data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 获取数据字典*/
export const getMMODictDataAction = createAsyncThunk('MMOSlice/getMMODictDataAction', async (dictType, thunkAPI) => {
    const nameDataDict = getMMODictTreeApi(dictType[0])
    return Promise.all([nameDataDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 获取数据 */
export const getMMODataAction = createAsyncThunk('MMOSlice/getMMODataAction', async (listDataParams, thunkAPI) => {
    try {
        const data = await getMMOByDateApi(listDataParams)
        return data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 保存数据 */
export const postMMODataAction = createAsyncThunk('MMOSlice/postMMODataAction', async ({ mmoObj }, { dispatch }) => {
    try {
        await postMMODataApi(mmoObj)
        return true // 已保存状态
    } catch (error) {
        dispatch(BoundarySlice.actions.addError(error))
    }
})

export const MMOSlice = createSlice({
    name: 'MMOSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.mmoData = null
            state.calendarData = null
            state.save = false
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getMMOCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getMMODictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        // /* 通过日期，获取 回显数据 */
        [getMMODataAction.fulfilled.type]: (state, action) => {
            state.mmoData = action.payload
        },
    },
})
